module.exports = __webpack_public_path__ + "img/xinshiwu.3629137c.jpg";